"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "select": {
    "imageUrl": "imageUrl",
    "title": "title",
    "description": "description",
    "metadata": "metadata",
    "typeLabel": "typeLabel"
  },

  prepare({
    formData,
    formContext
  }) {
    let documentType = formData.documentType,
        locale = formData.locale,
        title = formData.title,
        content = formData.content,
        description = formData.description;
    const defaultLocale = formContext.defaultLocale;
    const localeId = "locale:" + defaultLocale;
    let metadata = [];
    const headerImage = content && content.headerImage;
    const imageUrl = headerImage && headerImage.media && headerImage.media.imageUrl;

    if (content) {
      title = content.title && content.title[localeId];
      description = content.description && content.description[localeId];
      const location = content.location,
            sections = content.sections,
            isPartOf = content.isPartOf;

      if (location && location.lat && location.lng) {
        if (location.address) {
          metadata.push(location.address);
        } else {
          metadata.push("Sted");
        }
      }

      if (sections && sections.length) {
        metadata.push(sections.length + ' seksjoner');
      }

      if (isPartOf && isPartOf.length) {
        metadata.push(isPartOf.length + ' tema');
      }
    }

    return {
      imageUrl: imageUrl,
      title: title,
      description: description,
      metadata: metadata,
      typeLabel: documentType
    };
  }

};
exports.default = _default;
module.exports = exports.default;